import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private translate: TranslateService) { }

  changeLanguage(desiredLang?: string): Observable<any> {
    const userLang = localStorage.getItem('language');
    const browserLang = this.translate.getBrowserLang();
    let langToUse = this.translate.getDefaultLang();

    if (desiredLang && this.translate.getLangs().some(lang => lang === desiredLang)) {
      langToUse = desiredLang;
    } else if (userLang && this.translate.getLangs().some(lang => lang === userLang)) {
      langToUse = userLang;
    } else if (this.translate.getLangs().some(lang => lang === browserLang)) {
      langToUse = browserLang;
    }

    localStorage.setItem('language', langToUse);
    return this.translate.use(langToUse);
  }
}
